import React from 'react'
import Login from '../pages/login/Login'

export default function LoginRoutes() {
    return <Login />
}
